<template lang="pug">
  svg.svg-vent(:x="x" :y="y" :width="width" :height="height" viewBox="0 0 350 175" preserveAspectRatio="xMidYMid meet")
    title Hood
    polygon.vent-cls-1(points="341 140 41 140 20   1 310   1 341 140")
    polygon.vent-cls-2(points=" 41 140  1 170  1  24  20   1  41 140")
    polygon.vent-cls-3(points="341 140 41 140  1 170 301 170 341 140")
</template>

<script>
export default {
  name: 'svg-vent',

  props: {
    x: Number,
    y: Number,
    width: {
      type: Number,
      default: 350,
    },
    height: {
      type: Number,
      default: 175,
    },
  },

};
</script>

<style lang="scss" scoped>
.svg-vent {

  .vent-cls-1 {
    fill: var(--fill-color-1, #ccc);
    stroke: var(--stroke-color-1, #000);
    stroke-width: var(--stroke-width-1, 1px);
    stroke-miterlimit: 10;
    vector-effect: non-scaling-stroke;
  }
  .vent-cls-2 {
    fill: var(--fill-color-2, #b3b3b3);
    stroke: var(--stroke-color-2, #000);
    stroke-width: var(--stroke-width-2, 1px);
    stroke-miterlimit: 2;
    vector-effect: non-scaling-stroke;
  }
  .vent-cls-3 {
    fill: var(--fill-color-3, #333);
    stroke: var(--stroke-color-3, #000);
    stroke-width: var(--stroke-width-3, 1px);
    stroke-miterlimit: 2;
    vector-effect: non-scaling-stroke;
  }
}
</style>
